module.exports = __webpack_public_path__ + "static/media/schody53 - schody drewniane czarne z oswietleniem pod stopniami.81c6c724.jpg";